export const SORT_OPTIONS = [
    { value: "popular", labelKey: "sort.option.popular" },
    { value: "monthly_price", labelKey: "sort.option.monthly_price" },
    { value: "-monthly_price", labelKey: "sort.option.monthly_price_desc" },
];
export const SORT_PARAM = "sort";
export const DEFAULT_SORT = "popular";
/**
 * Matches `<offer_type>,<finance_type>,<monthly_price>` in list URLs
 * (see app/config/_urlManager.php: monthly_price allows [a-zA-Z0-9-]*).
 */
export const PATH_SEGMENT_TRIPLE = /(company|personal),(leasing|rent|loan),[a-zA-Z0-9-]+/;
export const DEFAULT_OFFER_TYPE = "company";
